/**
 * Validadores y regex reutilizables — GUIA_REACT_v2 §6.6.
 *
 * Las regex viven aquí (no inline en componentes) para mantener una sola
 * fuente de verdad de las reglas de validación; los schemas Zod en
 * `src/lib/schemas/` las consumen.
 */

/** RFC 5322 simplificado (suficiente para validación de UI). */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Teléfono nacional: exactamente 10 dígitos sin caracteres adicionales. */
export const PHONE_REGEX = /^\d{10}$/;

/** URL HTTP(S) válida. */
export const URL_REGEX = /^https?:\/\/[^\s]+$/;

/** ISO 8601 (yyyy-mm-dd). */
export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/** Helpers booleanos para usar fuera de schemas. */
export const isValidEmail = (v: string): boolean => EMAIL_REGEX.test(v.trim());
export const isValidPhone = (v: string): boolean => PHONE_REGEX.test(v.trim());
export const isValidUrl = (v: string): boolean => URL_REGEX.test(v.trim());
